import React, { useEffect, useState } from "react";
import { DataTable } from "./DataTable";
import { Button, Modal, Select } from "antd";
import { YhBox } from "@/components/YhBox";
import { useWrbModel } from "../wrbModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { IWarningTimeDs } from '@/types/FmsDs';
import useGlobalModel from '@/model/globalModel';
import { ISelectOption } from '@/components/YhFormBox/Types';
import { wcdService } from '../../customsDeclaration/wcdService';
import { globalPrompt } from '@/components/message';
const { Option } = Select
export const DataBox = () => {
    const { user: { shopCode, shopName } } = useGlobalModel()
    const { exportWrb, loadData } = useWrbModel();
    const [warningTime, setWarningTime] = useState('')
    let time: string
    const onTimeChange = (value: string, option: ISelectOption) => {
        time = value
    }

    // 获取预警设置
    const getWarningTime = async (type: string) => {
        let { retData } = await wcdService.select(type)
        if (retData) {
            let warningTime = retData[0]?.warningTime ?? ''
            setWarningTime(warningTime)
        } else {
            let warningTime = ''
            setWarningTime(warningTime)
        }
    }

    // 预警设置
    const onSave = async () => {
        const data = [{
            shopCode,
            shopName,
            warningTime: time as string,
            warningType: 'warning.proceeds'
        }]
        let { retData } = await wcdService.warning(data)
        if (retData) {
            getWarningTime('warning.proceeds')
            loadData()
            globalPrompt("message", { text: "预警设置成功,5分钟后生效！时间根据以具体设置时间为准", type: "success" })
        } else {
            globalPrompt("message", { text: "预警设置失败", type: "error" })
        }
    }

    useEffect(() => {
        getWarningTime('warning.proceeds')
    }, [])
    const onSet = () => {
        Modal.confirm({
            width: 500,
            title: '预警设置',
            content: (
                <>
                    <div>
                        预计收款日期提前<span style={{ marginLeft: 10, marginRight: 10 }}>
                            <Select
                                defaultValue={warningTime ?? ''}
                                style={{ width: 200 }}
                                options={IWarningTimeDs}
                                onChange={(value: string, options: any) => onTimeChange(value, options as ISelectOption)}
                            >
                            </Select>
                        </span>开启预警？</div>
                </>
            ),
            centered: true,
            okText: "确定",
            onOk: () => { onSave() },
            cancelText: "取消",
            onCancel: () => { },
        })
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => exportWrb()}
        >导出</Button>
        <YhAuth resCode={ResourceAuthEnum.W_R_WARN}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onSet}
            >预警设置</Button>
        </YhAuth>

    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}